var _rect, _rect2, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlPanelLightBlueWhiteBgRoundedShortRoundedLightBlueBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    fill: "#5062F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    stroke: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 33L13 11",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33L19 11",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33L25 11",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33L31 11",
    stroke: "#FFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 2,
    fill: "#5062F0",
    stroke: "#FFF",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0001,
    cy: 26.998,
    r: 2,
    fill: "#5062F0",
    stroke: "#FFF",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9999,
    cy: 15.998,
    r: 2,
    fill: "#5062F0",
    stroke: "#FFF",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 22,
    r: 2,
    fill: "#5062F0",
    stroke: "#FFF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlPanelLightBlueWhiteBgRoundedShortRoundedLightBlueBorder);
export default __webpack_public_path__ + "static/media/controlPanelLightBlueWhiteBgRoundedShortRoundedLightBlueBorder.bbeea5188e260d667449385242e1e862.svg";
export { ForwardRef as ReactComponent };